import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../../../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	/**
	 * V2-only override around each rendered V1 `QuestionField`.
	 *
	 * Why: V1's QuestionField renders a `<section>` whose direct child div
	 * (the QuestionContent wrapper) carries `marginBottom: spacing.lg`. When
	 * the `<section>` is a flex item inside V2's `expandedBody` (flex column),
	 * that child margin doesn't margin-collapse out of the parent's box, so the
	 * section's height extends past the visible card outline — and the colored
	 * left-border stripe (`borderLeft: 4px solid`) overshoots the bottom edge.
	 *
	 * We zero out only the inner div's `marginBottom` for V2-rendered questions.
	 * Inter-question spacing in V2 is supplied by `expandedBody`'s flex `gap`,
	 * so removing this margin doesn't compress the layout. V1's flat-list
	 * styling (`AdditionalQuestions/styles.ts`) is left untouched.
	 */
	questionContainer: {
		...CssSelectors.allDescendants({ marginBottom: 0 }, 'section > div'),
	},
});
